import PrimaryButton from "library/Atoms/Button/PrimaryButton";
import ModalLayout from "library/Layouts/ModalLayout";
import DefaultModal from "library/Molecules/Modal/DefaultModal";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ProofOfDeliveryModal = ({ dropReference, onClose, children }) => {
  const { t } = useTranslation();

  return (
    <DefaultModal
      id={`proof-of-${dropReference}-delivery-modal`}
      title={t("dashboard.modals.proofOfDeliveryModal.title")}
      onClose={onClose}
    >
      <ModalLayout
        modalControls={
          <PrimaryButton
            id="close-proof-of-delivery-modal-btn"
            className="w-100"
            label={t("common.buttons.closeBtn")}
            onClick={onClose}
          />
        }
      >
        {children}
      </ModalLayout>
    </DefaultModal>
  );
};

ProofOfDeliveryModal.propTypes = {
  dropReference: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ProofOfDeliveryModal;
